<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
  /* 全局样式 */
  *{
    margin: 0;
    padding: 0;
    list-style: none;
    box-sizing: border-box;
  }

  a {
    color: #000;
    text-decoration: none;
  }

  img{
    width: 100%;
  }

  html,
  body {
    width: 100%;
    height: 100%;
    font-size: 14px;
  }

  #app,
  .home{
    width: 100%;
    height: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue